export default __webpack_public_path__ + "static/portal_1-45e48c86cee0c3a7255a78046cd61a4d.mp4";